module.exports = __webpack_public_path__ + "img/rep-01-new.bbf693bb.png";